<template>
  <div class="col-md-3" @click="increment">
    <button class="btn-recharge" id="btnRecharge1" type="button" name="button">
      <span class="pull-right"
        ><span class="value-recharge" id="valueRecharge1">{{
          value | cents
        }}</span></span
      >
      <i class="icon-plus pull-left icon-center-recharge"></i>
    </button>
  </div>
</template>
<style scoped lang="scss">
.icon-center-recharge {
  border: 3.5px solid #613a7d;
  border-radius: 50%;
  padding: 4px 5px 5px;
  margin-top: 0;
}
</style>
<script>
//import sales from '../../../services/sales'
import C from "../../common/constantes";
import Auth from "../../../services/auth";
export default {
  props: {
    unit: Number,
    planId: [Number, String],
    roadCardUnit: undefined,
  },
  data() {
    return {
      value: "Carregando...",
      newValueRoadcard: undefined,
      valuesRoadCard: []
    };
  },
  created() {

    if ([C.PLAN_MAN_ECONOMICO, C.PLAN_AUT_ECONOMICO].includes(this.planId)) {
      this.value = C.RECHARGE_UNIT_ECONOMICO * this.unit;
    } else if (
      this.planId == C.PLAN_AUT_PJ ||
      this.planId == C.PLAN_MAN_PJ ||
      this.planId == C.PLAN_PRE_SEM_TAXA
    ) {
      this.value = C.RECHARGE_UNIT_PJ * this.unit;
    } else if (this.planId == C.PLAN_ROADCARD_PF) {
      this.newValueRoadcard = this.roadCardUnit * this.unit;
      this.value = C.RECHARGE_UNIT_ROADCARD_PF * this.newValueRoadcard;
      this.valuesRoadCard.push(this.value);
      this.$emit("valoresRecebidos",  this.valuesRoadCard );
    } else if (this.planId == C.PLAN_ROADCARD_PJ) {
      this.newValueRoadcard = this.roadCardUnit * this.unit;
      this.value = C.RECHARGE_UNIT_ROADCARD_PJ * this.newValueRoadcard;
      this.valuesRoadCard.push(this.value);
      this.$emit("valoresRecebidos",  this.valuesRoadCard );
    } else {
      this.value = C.RECHARGE_UNIT * this.unit;
    }
  },
  methods: {
    increment() {
      if (this.value > 0) this.$emit("increment", this.value);
    },
  },
};
</script>



// WEBPACK FOOTER //
// btn-recharge-value.vue?4d5f8a03